import React from "react";
import { NotificationProvider } from "@ipc/ipc-components";
import {
  Router,
  Route,
  LanguageProvider,
  LanguageRouting,
} from "@ipc/ipc-core";
import { MuiThemeProvider } from "material-ui";
import { getMuiTheme } from "material-ui/styles";
import { Provider } from "react-redux";
import { AppIntlProvider } from "./AppIntlProvider";
import { supportedLanguages } from "../../locales/locales";
import AppContainer from "./AppContainer";
import colors from "../../core/modules/common/colors";
import { store } from "../../store";
import "./request";

const AppLanguageRouting = (props) => (
  <LanguageRouting {...props} AppContainer={AppContainer} />
);

const getTheme = () => {
  const coreSettings = {
    palette: {
      primary1Color: "#0099CC",
      primary2Color: "#C50019",
    },
    radioButton: {
      borderColor: "#C9C9C9",
      labelColor: "#1F404B",
      checkedColor: colors.colorHighlight,
    },
  };

  return getMuiTheme({
    ...coreSettings,
  });
};

const Root = () => {
  const muiTheme = getTheme();
  return (
    <MuiThemeProvider muiTheme={muiTheme}>
      <LanguageProvider
        supportedLanguages={supportedLanguages}
        defaultLanguage="en"
      >
        <Provider store={store}>
          <NotificationProvider>
            <Router basename={process.env.basePath}>
              <AppIntlProvider>
                <Route component={AppLanguageRouting} />
              </AppIntlProvider>
            </Router>
          </NotificationProvider>
        </Provider>
      </LanguageProvider>
    </MuiThemeProvider>
  );
};

export default Root;
